import PropTypes from "prop-types";
import React from "react";

import { PropTypeShapes } from "../../types";

const FilterRow = props => (
  <div
    className={`${props.className || ""} filterRow ${props.collapsed ? "collapsed" : ""} ${
      props.indent ? "indent" : ""
    }`}
  >
    {props.label ? <label>{props.label}</label> : null}
    {props.children}
  </div>
);

FilterRow.propTypes = {
  className: PropTypes.string,
  label: PropTypes.string,
  children: PropTypeShapes.elementOrArray,
  collapsed: PropTypes.bool,
  indent: PropTypes.bool
};

export default FilterRow;
